import { Box, IconButton, Typography } from '@mui/material';
import React, { useState } from 'react';
import { West as WestIcon } from '@mui/icons-material';
import Icon from '../../Assets/Icon/CustomIcon';
import { useDispatch } from 'react-redux';
import { BottomSheetActions } from '../../Reducer/BottomSheetReducer';
import { PermitActions } from './../../Reducer/PermitReducer';
import { setSearchText } from '../../Reducer/SearchReducer';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

export default function AppBarPermit({ handleBack }) {
  const dispatch = useDispatch();
  const commonBoxStyle = {
    height: '56px',
    width: '100%',
    position: 'fixed',
    top: 0,
    zIndex: 100,
  };
  const [isSearchMode, setIsSearchMode] = useState(false);
  const [searchInput, setSearchInput] = useState('');
  const { depCd, depList } = useSelector((s) => s.searchInfo);
  const { selectedFilter } = useSelector((s) => s.permit);
  const { statusBar } = useSelector((state) => state.systemBar);

  const depName =
    depCd === ''
      ? '전체'
      : depList.find((d) => d.value === depCd)?.name || '전체';

  const handleSearch = () => {
    dispatch(setSearchText(searchInput));
    dispatch(PermitActions.requestSearch());
  };

  return (
    <Box
      sx={{
        ...commonBoxStyle,
        pt: `${statusBar}px`,
        height: `${statusBar + 56}px`,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        color: '#000000',
        px: '16px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          width: '100%',
          marginRight: '16px',
          minWidth: 0,
        }}
      >
        <IconButton edge="start" onClick={handleBack}>
          <WestIcon
            fontSize="large"
            sx={{
              color: '#000000',
              width: '24px',
              height: '24px',
            }}
          />
        </IconButton>
        {isSearchMode ? (
          <Box
            sx={{
              width: '100%',
              border: '1px solid #ccc',
              borderRadius: '8px',
              display: 'flex',
              alignItems: 'center',
              pr: '8px',
            }}
          >
            <input
              type="text"
              placeholder="신청인, 공사 업체명"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') handleSearch();
              }}
              style={{
                height: '36px',
                fontSize: '16px',
                padding: '0 10px',
                border: 'none',
                outline: 'none',
                width: '100%',
                backgroundColor: 'transparent',
              }}
            />
            <button
              style={{
                backgroundColor: 'transparent',
                border: 'none',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
              }}
              onClick={() => {
                setSearchInput('');
                handleSearch();
                setIsSearchMode(false);
              }}
            >
              <Icon.Close />
            </button>
          </Box>
        ) : (
          <button
            style={{
              backgroundColor: 'transparent',
              border: 'none',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              minWidth: 0,
              width: '100%',
            }}
            onClick={() => {
              dispatch(BottomSheetActions.OpenBottomSheet({ type: 'filter' }));
            }}
          >
            <Typography
              variant="h6"
              noWrap
              sx={{
                fontSize: '20px',
                fontWeight: 700,
                lineHeight: '32px',
                textAlign: 'left',
                flex: 1,
                minWidth: 0,
              }}
            >
              부서 : {depName}, 상태 : {selectedFilter}
            </Typography>
            <Icon.BottomArrow />
          </button>
        )}
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          flexShrink: 0,
        }}
      >
        <IconButton
          edge="start"
          sx={{ paddingRight: '0px', color: '#000000' }}
          onClick={() => {
            if (isSearchMode) {
              handleSearch();
            } else {
              setIsSearchMode(true);
            }
          }}
        >
          <Icon.Search />
        </IconButton>
      </Box>
    </Box>
  );
}

AppBarPermit.propTypes = {
  handleBack: PropTypes.func.isRequired,
};
